import type { Common } from '@libs/domain';
import type { OutputFileFormat } from '@libs/enums';

export class OutputOperations implements Pick<Common['schema'], 'jobComment' | 'outputFileFormat'> {
  private constructor(
    readonly outputFileFormat: Set<OutputFileFormat>,
    readonly jobComment: string,
  ) {}

  static init(...outputFileFormats: OutputFileFormat[]) {
    return new OutputOperations(new Set<OutputFileFormat>(outputFileFormats), '');
  }
}

export class OutputOperationsRaw implements Pick<Common['record'], 'jobComment' | 'outputFileFormat'> {
  private constructor(
    readonly outputFileFormat: string[],
    readonly jobComment: string,
  ) {}

  static fromModel(outputOps: OutputOperations) {
    return new OutputOperationsRaw([...outputOps.outputFileFormat], outputOps.jobComment);
  }
}
